import * as React from "react";

import { GlideFunctionalRenderer } from "common/components/uis";
import { ActionSource, LOADING } from "common/components/types";
import { evalSummary, makeDropImageHandler } from "common/components/portable-renderers";
import {
    loadedDefinedMapWithDefault,
    asString,
    loadedDefinedMap,
    asBoolean,
} from "common/components/component-helpers";
import { checkString } from "common/Support";
import { definedMap } from "@glideapps/ts-necessities";
import { Icon } from "common/components/icons";
import ListItem from "../../ui/deprecated/ListItem";
import { makeOnClickFromAction } from "../../ui/deprecated/components";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const ListItemMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [
        [titleValue, subtitleValue, , icon, fallbackInitials, allowWrapping, onTap, onDropImage, actionSource, style],
        [, , imageVP],
    ] = useForceValueProducers(getValueProducers, force, ctx);
    const { title, subtitle, imageSource } = evalSummary(titleValue, subtitleValue, imageVP, force);

    const source = loadedDefinedMapWithDefault(
        actionSource,
        ActionSource.ListItem,
        v => checkString(v) as ActionSource
    );
    const { onClick, targetURL } = makeOnClickFromAction(onTap, source, ctx, env);

    let fallback: string | undefined;
    if (fallbackInitials === LOADING) {
        fallback = "";
    } else {
        fallback = definedMap(fallbackInitials, asString);
    }

    const iconName = loadedDefinedMap(icon, asString) as Icon | undefined;
    const styleVal = loadedDefinedMap(style, asString) as "inverted" | "normal" | undefined;

    return (
        <ListItem
            text={titleValue === LOADING ? LOADING : title}
            detail={subtitleValue === LOADING ? LOADING : subtitle}
            imageSource={imageSource}
            style={styleVal}
            fallbackInitials={fallback}
            interactive={onClick !== undefined}
            onClick={onClick}
            targetUrl={targetURL}
            appID={env.appEnvironment.appID}
            onDropImage={makeDropImageHandler(env, onDropImage, ActionSource.ListItem)}
            allowWrapping={loadedDefinedMapWithDefault(allowWrapping, false, asBoolean)}
            menuItems={definedMap(iconName, i => [
                {
                    title: i,
                    icon: i,
                },
            ])}
        />
    );
};
